/** SphereMesh resource slice: claims the type name, re-exports its decode. */
import { registerGenericResourceSlice } from '../../sliceRegistration.js';
registerGenericResourceSlice('spheremesh', ['SphereMesh']);
//# sourceMappingURL=index.js.map